import { useCallback, useEffect, useMemo, useRef } from 'react';
import { docStream, docStreamShellHtml } from '~/design-system/components/DeckGen/birtvy/docStream';
import { NO_RECORDING } from '~/lib/noRecording';

/** The same persistent, sandboxed stream shell as the canvas; never reload the frame per token. */
export function StreamingArtifactDocument({ slideId, title, seed }: { slideId: number; title: string; seed?: string }) {
  const frame = useRef<HTMLIFrameElement>(null);
  const html = useMemo(docStreamShellHtml, []);
  const initialSeed = useRef(seed);
  const subscription = useRef<(() => void) | undefined>();
  const onLoad = useCallback(() => {
    const node = frame.current;
    if (!node) return;
      subscription.current?.();
      const target = node.contentWindow;
      if (!target) return;
      let bytes = 0;
      node.dataset.streamState = 'ready';
      target.postMessage({ __bds: 1, t: 'hello', seed: initialSeed.current, ground: true, skeleton: false }, '*');
      subscription.current = docStream.subscribe(slideId, event => {
        if (event.delta != null) { bytes += event.delta.length; target.postMessage({ __bds: 1, t: 'chunk', s: event.delta }, '*'); }
        if (event.refresh != null) { bytes = event.refresh.length; target.postMessage({ __bds: 1, t: 'refresh', s: event.refresh }, '*'); }
        node.dataset.streamBytes = String(bytes);
        node.dataset.streamState = event.done ? 'done' : 'streaming';
        if (event.done) target.postMessage({ __bds: 1, t: 'done' }, '*');
      });
  }, [slideId]);
  useEffect(() => () => subscription.current?.(), []);
  return <iframe ref={frame} onLoad={onLoad} srcDoc={html} sandbox="allow-scripts" className={NO_RECORDING} title={`${title} — live generation`}
    style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 0 }} />;
}
